import { useGetFacilitiesV2Query } from "@/features/api/apiSlice";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import ErrorBoundary from "@/components/ErrorBoundary";

export const UnitError = () => {
    const options = useDisplayOptionContext();

    const { data, error, isLoading } = useGetFacilitiesV2Query({
        ids: options.facilityIds[0],
    });
    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <h2>
                        We're sorry, we are having trouble retrieving units at
                        this time.
                    </h2>
                </CardTitle>
            </CardHeader>
            <CardContent>
                {error ? (
                    "Oh no, there was an error! {error.status}"
                ) : isLoading ? (
                    <Skeleton className="tw:w-[200px] tw:h-[20px] tw:rounded-full" />
                ) : data && data.data && data.data.length > 0 ? (
                    <ErrorBoundary>
                        <p>
                            For more information on unit availability, please call{" "}
                            <a href="{data.data[0].phone}">{data.data[0].phone}</a>
                        </p>
                    </ErrorBoundary>
                ) : null}
            </CardContent>
        </Card>
    );
};
